module.exports = __webpack_public_path__ + "img/menu-list.1cd31abc.svg";